import i18n from 'i18next';
import { initReactI18next, useTranslation } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
// not like to use this?
// have a look at the Quick start guide 
// for passing in lng and translations on init

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'en',
    backend: {
      /* translation file path */
      loadPath: (lngs: string[], namespaces: string[]) => {
        const namespace = namespaces[0];
        
        // Handle hierarchical namespaces (components/balanceCard, pages/login, etc.)
        if (namespace.includes('/')) {
          return `/assets/i18n/translations/{{lng}}/${namespace}.json`;
        }
        
        // Handle dot notation namespaces (components.balanceCard -> components/balanceCard)
        if (namespace.includes('.') && namespace !== 'translations') {
          const hierarchicalPath = namespace.replace(/\./g, '/');
          return `/assets/i18n/translations/{{lng}}/${hierarchicalPath}.json`;
        }
        
        // Default path for main translations
        return '/assets/i18n/translations/{{lng}}.json';
      }
    },
    debug: true,
    /* can have multiple namespace, in case you want to divide a huge translation into smaller pieces and load them on demand */
    ns: ['translations', 'components/balanceCard', 'components/quickActions', 'components/accountSummary'],
    defaultNS: 'translations',
    keySeparator: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      formatSeparator: ','
    }
  });

export default i18n;